import $ from "jquery";
import objectFitImages from "object-fit-images";
import svg4everybody from "svg4everybody";
import "jquery-validation";
import "jquery-validation-unobtrusive";
import "lazysizes";
import "picturefill";
import "responsive-bp";
import "@accessible360/accessible-slick";
import "@fancyapps/fancybox";

import uiHelpers from "./ui-helpers";

svg4everybody();
uiHelpers.init();
objectFitImages();

// include any plugin initialisation here
// any custom JS that needs to be written should be modular (and in a separate file), possibly done as a jQuery plugin or some other modular form, and initialised here like the other plugins
$(".no-js").removeClass("no-js");

// Send scrolling events to Google Analytics http://scrolldepth.parsnip.io/
if (typeof $.scrollDepth === "function") {
  $.scrollDepth();
}

// Sticky header & alert bar
if ($(window).width() >= 1280) {
  const offset = 6;
  let alertBarHeight = 0;

  const headerLogo = $(".primary-header__large-logo");
  const headerLogoSmall = $(".primary-header__small-logo");
  const primaryNav = $(".primary-navigation");

  const headerHeight = $(".primary-header").outerHeight();
  const innerHeaderHeight = $(".primary-header__inner").outerHeight();

  if ($(".alert-bar--visible").length) {
    alertBarHeight = $(".alert-bar--visible").outerHeight();
  }

  if (alertBarHeight > 0) {
    $(".primary-header__inner").css("top", alertBarHeight);
  }

  $(".js-alert-accept").on("click", () => {
    $(".primary-header__inner").css("top", 0);
    alertBarHeight = 0;
  });

  $(window).scroll(() => {
    const scrollTop = $(window).scrollTop();
    const calculatedScrollTop =
      scrollTop +
      (innerHeaderHeight + primaryNav.outerHeight() - alertBarHeight) -
      offset;

    // Handle toggle between the two logos
    if (scrollTop) {
      headerLogo.css({ opacity: 0 });
      headerLogoSmall.css({ opacity: 1 });
    } else {
      headerLogo.css({ opacity: 1 });
      headerLogoSmall.css({ opacity: 0 });
    }

    // Handle sticky nav
    if (calculatedScrollTop >= headerHeight) {
      primaryNav.addClass("fixed");
      $("body").css("padding-top", primaryNav.outerHeight());
    } else {
      primaryNav.removeClass("fixed");
      $("body").removeAttr("style");
    }

    // Handle top bar if alert is visible
    if ($(".alert-bar--visible").length) {
      if (scrollTop <= alertBarHeight) {
        $(".primary-header__inner").css("top", alertBarHeight - scrollTop);
      } else {
        $(".primary-header__inner").css("top", 0);
      }
    }
  });
}

const subMenuList = $(".primary-navigation__list-item--has-subnav");
const subMenuLink = $(
  ".primary-navigation__list-item--has-subnav > .primary-navigation__list-item-actual"
);

// Mobile expanding links
subMenuLink.click((e: MouseEvent) => {
  // Prevent navigating to the parent link
  if ($(window).width() <= 1280) {
    e.preventDefault();
    const clickedElement = $(e.target);
    const targetElement = clickedElement.closest(subMenuList);

    targetElement.toggleClass("primary-navigation__list-item--expanded");
  }
});

// Navigation
addListenersToNav();

$(window).resize(() => {
  addListenersToNav();
});

function addListenersToNav() {
  if ($(window).width() <= 1280) {
    // Unbind
    $(".js-menu-toggle").unbind("click");

    // Rebind
    $(".js-menu-toggle").on("click", function (e) {
      $(this).toggleClass("active");
      $(".js-menu").toggleClass("active");
      $("body").toggleClass("no-scroll");
      e.preventDefault();
    });
  }
}

// Search
$(".js-search-open").on("click", (e) => {
  $("body").toggleClass("no-scroll");
  $(".search__modal").toggleClass("is-visible");
  e.preventDefault();
});

$(".js-search-close").on("click", (e) => {
  $("body").removeClass("no-scroll");
  $(".search__modal").removeClass("is-visible");
  e.preventDefault();
});

$(document).keyup((e) => {
  if (e.keyCode === 27) {
    if ($(".search__modal").hasClass("is-visible")) {
      $("body").removeClass("no-scroll");
      $(".search__modal").removeClass("is-visible");
    }
  }
});

// Accordions
const acc = document.getElementsByClassName("js-accordion");
let i: number;

for (i = 0; i < acc.length; i++) {
  acc[i].addEventListener("click", function () {
    const panel = this.nextElementSibling;

    this.parentNode.classList.toggle("active");

    if (panel.style.maxHeight) {
      panel.style.maxHeight = null;
    } else {
      panel.style.maxHeight = panel.scrollHeight + "px";
    }
  });
}

// Accessible Slick
$(".js-slider").slick({
  arrows: true,
  dots: false,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        arrows: false,
        dots: true,
      },
    },
  ],
  slidesToScroll: 1,
  slidesToShow: 1,
});

// Tabbed content
$(".js-tab").on("click", function () {
  const index = $(this).index() + 1;
  const tabList = $(this).parent();
  const tabs = tabList.parent().next();

  $(this).addClass("active").siblings().removeClass("active");
  tabs.find("> div").removeClass("active");
  tabs.find("> div:nth-child(" + index + ")").addClass("active");
  tabList.removeClass("open");
});

$("body")
  .find(".js-mobile-tab")
  .on("click", function (e) {
    const tabList = $(this).next();
    tabList.toggleClass("open");
    e.preventDefault();
  });

// Map interactions
const tooltip = document.querySelectorAll(".school-map__tooltip");

[].forEach.call(tooltip, (el) => {
  // Create tooltip element
  const target = el.getAttribute("data-target");

  // Add tooltip to body on mouse over
  el.addEventListener(
    "mouseover",
    function (e) {
      const mapTop = $(".school-map").offset().top;
      const heightVal = $(this).height();
      const boxTop = $(this).offset().top - mapTop + heightVal + "px";
      const boxLeft = $(this).offset().left + 10 + "px";
      const insetValues = boxTop + " auto auto " + boxLeft;

      $("." + target)
        .css("inset", insetValues)
        .addClass("active");
    },
    false
  );

  // Remove tooltip on mouseout
  el.addEventListener(
    "mouseout",
    (e) => {
      $("." + target).removeClass("active");
    },
    false
  );
});

document.addEventListener("contextmenu", (e: MouseEvent) => {
  e.preventDefault();
});
